import gql from 'graphql-tag';

export const updateServiceRequestStatusByUCIIdMutation = gql`
  mutation updateServiceRequestStatusByUCIIdMutation(
    $uciId: String!
    $status: String!
  ) {
    updateServiceRequestStatusByUCIId(uciId: $uciId, status: $status)
  }
`;
